import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const BrandNameFlex = styled(Flex)`
  margin: 140px 0 0 0;
`
export const NoitemDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: 12px;
  line-height: 18px;
  color: ${COLORS.GREY_T_60};
  margin: 10px 0 15px;
`
export const WrapperDiv = styled.div`
  height: 80vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`
export const CollageNameFlex = styled(Flex)`
  flex-direction: column;
  gap: 5px;
  margin-left: 10px;
`
export const CollegeNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  color: ${COLORS.GREY_T_20};
`
export const CollegeCity = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_XS};
  color: ${COLORS.GREY_T_60};
`
export const CollageDetailsFlex = styled(Flex)`
  line-height: normal;
  width: 100%;
  align-items: center;
`
export const SelectClgDiv = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
  &:hover {
    cursor: pointer;
  }
`
export const FooterFlex = styled(Flex)`
  gap: 15px;
`

export const RemoveTextDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`
